import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

import type { DataTablePagination } from './data-table.interface'
import {
  DataTableContent,
  type DataTableContentComponentProps,
} from './data-table-content.molecule'
import { DataTablePagination as DataTablePaginationComponent } from './data-table-pagination.molecule'

export interface DataTableViewProps<TData> extends DataTableContentComponentProps<TData> {
  toolbar: ReactNode
  pagination?: DataTablePagination
  onPageChange?: (page: number) => void
  onPageSizeChange?: (pageSize: number) => void
  className?: string
}

const DataTableViewInner = <TData,>({
  toolbar,
  pagination,
  onPageChange,
  onPageSizeChange,
  className,
  ...contentProps
}: DataTableViewProps<TData>): ReactNode => (
  <div className={cn('data-table-wrapper space-y-4', className)}>
    {toolbar}
    <DataTableContent {...contentProps} />
    {pagination && (
      <DataTablePaginationComponent
        pagination={pagination}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    )}
  </div>
)

export const DataTableView = memo(DataTableViewInner) as typeof DataTableViewInner
